import {ErrorHandler, NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HttpClientXsrfModule, HttpXsrfTokenExtractor} from '@angular/common/http';
import {LF_ERROR_IS_PROD_ENV, LF_ERROR_REPORTING_URL, LfAtThemeModule, LfErrorHandler} from 'lf-at-theme';
import {RouterModule} from '@angular/router';
import {OssHttpXsrfTokenExtractor} from './shared';
import {RegistoFormsRoutingModule} from './registo-forms-routing.module';
import {RegistoFormsRootComponent} from './registo-forms-root.component';
import {ROUTER_BASE_PATH as UNION_BASE_PATH} from './union/tokens';
import {ROUTER_BASE_PATH as NON_UN_BASE_PATH} from './non-union/tokens';
import {ROUTER_BASE_PATH as IMPORT_BASE_PATH} from './import/tokens';
import {ROUTER_BASE_PATH as INT_BASE_PATH} from './intermediary/tokens';


/** Standalone AppModule */
@NgModule({
  declarations: [
    RegistoFormsRootComponent,
  ],
  imports: [
    CommonModule,
    LfAtThemeModule.forRoot(),
    HttpClientXsrfModule.withOptions({headerName: 'X-CSRF-TOKEN'}),
    RegistoFormsRoutingModule,
    RouterModule.forRoot([])
  ],
  bootstrap: [RegistoFormsRootComponent],
  providers: [
    {provide: UNION_BASE_PATH, useValue: 'union'},
    {provide: NON_UN_BASE_PATH, useValue: 'non-union'},
    {provide: IMPORT_BASE_PATH, useValue: 'import'},
    {provide: INT_BASE_PATH, useValue: 'intermediary'},
    //Angular only supports a global error handler so these providers were moved here, ie the root module.
    {provide: LF_ERROR_REPORTING_URL, useValue: '/oss/forms/reporting/error'},
    {provide: LF_ERROR_IS_PROD_ENV, useValue: false},
    {provide: ErrorHandler, useClass: LfErrorHandler},
    //Angular only supports a global XsrfTokenExtractor, so this provider was moved here.
    {provide: HttpXsrfTokenExtractor, useClass: OssHttpXsrfTokenExtractor},

  ]
})
export class RegistoFormsModule {
}
